import * as types from "../actions/actionType";

const paymentReducer = (state, action) => {
  if(state===null || state===undefined){
		state={};
	}
  switch (action.type) {
    case types.CAPTURE_TRANSACTION_INFO:
      return {
        ...state,
        paymentInfo: action.accountInfo
      }

    default:
      return state;

  }
}

export default paymentReducer;



// WEBPACK FOOTER //
// ./src/reducers/paymentReducer.js